import * as L from 'leaflet';
import * as kmz from 'leaflet-kmz';
import AwsTirol from './AwsTirol';
import { FreerideLineLayer } from './FreerideLines';
import { FreeridePolyLayer } from './FreeridePolys';
import Partner from './Partner';
import { PoiLayer } from './FreeridePois';
import { WaldWildLayer } from './WaldWild';
import { baseLayer, slopeLayer, pistsLayer, basemap_at, orthoLayer, pmtilesLayer, contourLayer } from './Maplayers';
import 'leaflet-hash';
import { WebcamLayer } from './WebcamLayer';

class Basemap {

  map;
  pois;
  webcams;
  polys;
  lines;
  opts;

  constructor(ele, opts = { center: [47.2670, 11.3920], zoom: 9, frLayers: true }) {
    this.map = L.map(ele, opts);
    this.opts = opts;
    this.init();
  }

  init() {
    const aws = new AwsTirol();
    const partners = new Partner();
    this.map.addLayer(partners);
    this.map.addLayer(baseLayer);
    this.map.addLayer(pistsLayer);
    this.map.addLayer(slopeLayer);
    this.map.attributionControl.setPrefix('');
    const baseLayers = {
      "snowhow": baseLayer,
      "basemap.at": basemap_at,
      "Orthofoto Austria": orthoLayer,
      "World Map": pmtilesLayer,
    };
    const overlays = {
      "Hangneigung": slopeLayer,
      "Pisten": pistsLayer,
      "Wetterstationen Tirol": aws,
    };
    if (this.opts.frLayers === true) {
      this.pois = new PoiLayer();
      this.webcams = new WebcamLayer();
      this.polys = new FreeridePolyLayer();
      this.lines = new FreerideLineLayer();
      this.waldwild = new WaldWildLayer();
      this.map.addLayer(this.pois);
      this.map.addLayer(this.webcams);
      this.map.addLayer(this.lines);
      this.map.addLayer(this.polys);
      this.map.addLayer(this.waldwild);
      overlays['Freeride Info'] = this.pois;
      overlays['Webcams'] = this.webcams;
      overlays['snowhow tracks'] = this.lines;
      overlays['snowhow freeride areas'] = this.polys;
      overlays['Wald/Wild'] = this.waldwild;
    }
    this.map.on('baselayerchange', (e) => {
      if (e.layer === pmtilesLayer) {
        this.map.addLayer(contourLayer);
      } else if (this.map.hasLayer(contourLayer)) {
        this.map.removeLayer(contourLayer);
      }
    });
    new L.Hash(this.map);
    // eslint-disable-next-line no-unused-vars
    const layerControl = L.control.layers(baseLayers, overlays).addTo(this.map);
    L.control.scale().addTo(this.map);
    console.log('Basemap initialized', kmz);
//     const kmzL = L.kmzLayer().addTo(this.map);
//     kmzL.on('load', function(e) {
//       console.log('layer loaded: ', e.layer, e)
//       layerControl.addOverlay(e.layer, e.name);
//       // this.map.fitBounds(e.layer.getBounds());
//       // e.layer.addTo(this.map);
//     });
//     const files = [
// "MKS_WWU_2021_E-70_NH64_7.kmz",
// "Pretul1_WWU_2021_E-82_NH78_10.kmz",
// "Pretul1_WWU_2021_E-82_NH78_11.kmz",
// "Pretul1_WWU_2021_E-82_NH78_12.kmz",
// "Pretul1_WWU_2021_E-82_NH78_13.kmz",
// "Pretul1_WWU_2021_E-82_NH78_14.kmz",
// "Pretul1_WWU_2021_E-82_NH78_1.kmz",
// "Pretul1_WWU_2021_E-82_NH78_2.kmz",
// "Pretul1_WWU_2021_E-82_NH78_3.kmz",
// "Pretul1_WWU_2021_E-82_NH78_4.kmz",
// "Pretul1_WWU_2021_E-82_NH78_5.kmz",
// "Pretul1_WWU_2021_E-82_NH78_6.kmz",
// "Pretul1_WWU_2021_E-82_NH78_7.kmz",
// "Pretul1_WWU_2021_E-82_NH78_8.kmz",
// "Pretul1_WWU_2021_E-82_NH78_9.kmz",
//     ];
//     for (const file of files) {
//       kmzL.load(`/sh/kmz/${file}`);

//     }
  }


}

export default Basemap;